module.exports = __webpack_public_path__ + "static/media/jobs-hover.95e27ebd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jobs-hover.jpg
// module id = 194
// module chunks = 0